import { Box, Button, Flex, customStyled } from '@mafc/trolly';

export const ReplaceRow = customStyled(Flex)(
  ({ theme: { colors, fontSizes, fontWeights, space } }) => ({
    fontSize: fontSizes[1],
    color: colors.black,
    fontWeight: fontWeights[7],
    marginBottom: space[3],
    justifyContent: 'space-between',
    alignItems: 'center',
  })
);

export const ReplaceBtn = customStyled(Button)(props => ({
  fontSize: props.theme.fontSizes[2],
  fontWeight: props.theme.fontWeights[6],
  height: 'auto',
  padding: '10px 24px',
  textTransform: 'none',
  borderRadius: props.theme.radii[3],
  lineHeight: '20px',
  display: 'flex',
  alignItems: 'center',
}));

export const ReplaceIcon = customStyled(Box)(({ theme: { colors, fontSizes, fontWeights } }) => ({
  marginRight: '12px',
  transform: 'rotate(270deg)',
  height: '24px',
}));
